import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const Headline = styled(EntityLink)`
  display: -webkit-box;

  font-size: 16px !important;
  font-family: ${fontRoboto} !important;
  line-height: 19px !important;
  white-space: nowrap;
  text-overflow: ellipsis;

  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Container = styled.li`
  margin-inline: 20px 0 !important;
  padding: 0 !important;
  &::marker {
    color: #2c4692;
    font-size: 16px;
    line-height: 19px;
  }
`;
